import { CRM_DEACTIVATED } from 'constants/crmConstant'
import React, { useEffect, useState } from 'react'
import FontAwesome from 'react-fontawesome'
import userApi from '../../../services/userApi'
import { CONSTANTS } from '../../../utils/constants'
import Utils from '../../../utils/utils'
import AutocompletionWithoutListing from './AutocompletionWithoutListing'
import CustomList from './CustomList'
import './EstateUsersEditionTableRow.scss'
import ModalDeactivateUser from './ModalDeactivateUser'
import SupervisorsList from './SupervisorsList'

const EstateUsersEditionTableRow = ({ user, index, handleChange, fetchUsers, agencies, managers, userList, onEditAddress, fetchManagers }) => {
  const [editMode, setEditMode] = useState(false)
  const [copyMode, setCopyMode] = useState(false)
  const [copyTarget, setCopyTarget] = useState(null)
  const [showDeactivateModal, setShowDeactivateModal] = useState(false)
  const [estateUser, setEstateUser] = useState(user)

  const switchMode = () => {
    if (editMode) {
      userApi.updateUser(estateUser).then(() => {
        fetchUsers()
        fetchManagers()
      })
    }

    setEditMode((prevEditMode) => !prevEditMode)
  }

  const copyUserTo = () => {
    if (copyTarget) {
      let updatedUser = { ...copyTarget }
      updatedUser.agencies = [...estateUser.agencies, ...updatedUser.agencies].reduce((acc, curr) => {
        if (!acc.some((agency) => agency.id === curr.id)) {
          return [...acc, curr]
        }
        return acc
      }, [])

      userApi.updateUser(updatedUser).then(() => fetchUsers())
    }
    setCopyMode(!copyMode)
    setCopyTarget(null)
  }

  const handleItemChange = (type, items) => {
    setEstateUser((prevUser) => ({
      ...prevUser,
      [type]: items,
    }))

    handleChange(type, index, items)
  }

  const toggleDeactivateModal = () => {
    setShowDeactivateModal(!showDeactivateModal)
  }

  const handleDeactivateUser = () => {
    userApi.deactivateUser(estateUser.id).then((_response) => {
      setEstateUser((prevUser) => ({
        ...prevUser,
        status: CRM_DEACTIVATED,
      }))
    })
  }

  const { firstname, lastname, agencies: userAgencies, supervisors, roles, username, status } = estateUser || user
  const isKeeper = roles.some((role) => role.label === CONSTANTS.ROLES.KEEPER)

  useEffect(() => {
    setEstateUser(user)
  }, [user])

  return (
    <tr style={{ color: status === CRM_DEACTIVATED ? 'lightgrey' : '' }}>
      <td className="col-2">{lastname ? `${firstname} ${lastname}` : username}</td>
      <td className="col-4">
        <div className="d-flex">
          <CustomList
            type="agencies"
            items={userAgencies}
            handleChange={handleItemChange}
            selectables={agencies}
            deactivated={status === CRM_DEACTIVATED}
            toShow="label"
          />
          {editMode && (
            <div className="action-button small ml-3" onClick={() => onEditAddress(estateUser)}>
              <FontAwesome name="edit" />
            </div>
          )}
        </div>
      </td>
      <td className="col-4">
        {isKeeper && (
          <SupervisorsList
            items={supervisors}
            handleChange={handleItemChange}
            editMode={editMode}
            selectables={managers || []}
            deactivated={status === CRM_DEACTIVATED}
          />
        )}
      </td>
      <td className="col-2" style={{ color: status === CRM_DEACTIVATED ? '' : isKeeper ? 'red' : 'blue' }}>
        {roles[0] ? Utils.getRoleName(roles[0].label).toUpperCase() : ''}
      </td>
      <td className="d-flex flex-column">
        <div
          className={`action-button small mb-3 ${status === CRM_DEACTIVATED ? 'disabled' : ''}`}
          onClick={status !== CRM_DEACTIVATED ? switchMode : undefined}
        >
          <FontAwesome name={editMode ? 'save' : 'edit'} />
        </div>
        <div className="d-flex flex-column">
          <div className="action-button small mb-3" onClick={copyUserTo}>
            <FontAwesome name={copyMode ? 'paste' : 'copy'} />
          </div>
          {copyMode && (
            <div className="autocomplete-container">
              <AutocompletionWithoutListing suggestions={userList} toShow="fullname" onSelect={setCopyTarget} keepSelection={true} />
            </div>
          )}
          {/* TODO: réactiver une fois le modification du service CRM appliquée par l'USH */}
          {/* <DeactivateUserButton
            isDeactivated={estateUser.status && estateUser.status === CRM_DEACTIVATED}
            onClick={toggleDeactivateModal}
            className="mb-0"
          /> */}
        </div>
      </td>
      <ModalDeactivateUser
        showModal={showDeactivateModal}
        toggleModal={toggleDeactivateModal}
        onConfirm={handleDeactivateUser}
        fetchUsers={fetchUsers}
      />
    </tr>
  )
}

export default EstateUsersEditionTableRow
